module.exports = __webpack_public_path__ + "ddf0f0a4e8bb9daa6978d060624379a2.svg";